export default __webpack_public_path__ + "static/media/icon_circle_close.dfd1d8ed.svg";